// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"policy_privacyPolicy__rnlj4","title":"policy_title__ykCWo","subtitle":"policy_subtitle__SiGqV","section":"policy_section__9t9Ha"};